import { render } from "./JobDetail.vue?vue&type=template&id=45ce8241&scoped=true"
import script from "./JobDetail.vue?vue&type=script&lang=js"
export * from "./JobDetail.vue?vue&type=script&lang=js"

import "./JobDetail.vue?vue&type=style&index=0&id=45ce8241&scoped=true&lang=css"

import exportComponent from "/__w/caption-cafe-web/caption-cafe-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ce8241"]])

export default __exports__